module.exports = __webpack_public_path__ + "img/94a33e6.webp";